import React from 'react';
import { navigate } from 'gatsby';
import { Column, Button, Card } from '@codeparva/ui-components-library';
import { CheckBalanceTypes } from '../../CheckBalanceTypes';
import { checkBalanceLabels } from '../../constants/accountPanelConfigs';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { mobilescreensize } from '../../../../utilities/constants';

export const BalanceDetails = ({
  ledger_balance = 0,
  payment_page_url,
}: CheckBalanceTypes.TBalanceDetails) => {
  const {
    balanceDetailsMainLabel,
    currency_sign_dollar,
    balanceSectionLabel,
    buttonText,
  } = checkBalanceLabels;
  const { width } = useWindowDimensions();

  const getPaymentButton = () => {
    return (
      <>
        <div className="buttonContainer">
          <Button
            className="makePaymentButton"
            onClick={() => navigate(payment_page_url)}
          >
            {buttonText}
          </Button>
        </div>
      </>
    );
  };

  return (
    <Column className="balanceDetailsContainer">
      <div className="balanceDetailsLabel">
        <h5>{balanceDetailsMainLabel}</h5>
      </div>
      <div className="balanceDetailsTiles">
        <Card>
          <div className="individualTile">
            <div>
              <div className="tileData">
                <h4>
                  {currency_sign_dollar} {ledger_balance}
                </h4>
              </div>
              <p className="subtitle1">{balanceSectionLabel}</p>
            </div>
            {width > mobilescreensize ? getPaymentButton() : <></>}
          </div>
        </Card>
        {width <= mobilescreensize ? getPaymentButton() : <></>}
      </div>
    </Column>
  );
};
